<template>
	<div>
		<div class="inbox">
			<bsf-page-header>
				<h3 slot="header">欢迎使用VBAdmin </h3>
			</bsf-page-header>
			<bsf-layout>
				<bsf-col size="xs" col="3">
					<bsf-note :data="noteData" type="hasol"></bsf-note>
				</bsf-col>
				<bsf-col size="xs" col="9">
					<bsf-layout class="cavmix-box">
						<!--<bsf-col size="xs" col="12" class="tits">
							<span class="pull-right text-right">
								<small>Average value of sales in the past month in: United states </small>
								<br />All sales: 162,862
							</span>
							<h4 class="tit">图表的完整名称主标题在这里</h4>
							<h5 class="tit1">图表的副标题</h5>
						</bsf-col>-->
						<bsf-col size="xs" col="9">
							<bsf-chart cheight="200" :data="chartData1.chart" ctype="line" :areaStyle="true" :toolbox="false">
							</bsf-chart>
							<p class="info">{{chartData1.chartmsg}}</p>
						</bsf-col>
						<bsf-col size="xs" col="3" class="countmsg">
							<template v-for="(count,index) in chartData1.chart">
								<h3> ${{count.data|count}}000</h3>
								<p>{{count.name}}</p>
								<bsf-progress :state="70" :end="true" type="info" striped animate></bsf-progress>
							</template>
						</bsf-col>
					</bsf-layout>
				</bsf-col>
			</bsf-layout>
		</div>
		<div class="container-fluid">
			<bsf-col size="xs" col="2">
				<bsf-panel class="titinfo">
					<h5 class="panel-title" slot="title">浏览量<bsf-label class="pull-right" type="success">本周</bsf-label></h5>
					<template slot="body">
						<h2 class="tits">25,600</h2>
						<p class="info">总浏览量<span class="pull-right">206<icon icon="arrow-top-b"></icon></span></p>
					</template>
				</bsf-panel>
			</bsf-col>
			<bsf-col size="xs" col="2">
				<bsf-panel class="titinfo">
					<h5 class="panel-title" slot="title">注册量<bsf-label class="pull-right" type="danger">今日</bsf-label></h5>
					<template slot="body">
						<h2 class="tits">25,600</h2>
						<p class="info">总浏览量<span class="pull-right">206<icon icon="arrow-top-b"></icon></span></p>
					</template>
				</bsf-panel>
			</bsf-col>
			<bsf-col size="xs" col="4">
				<bsf-panel class="titinfo">
					<h5 class="panel-title" slot="title">图表 </h5>
					<template slot="body">
						<bsf-layout>
							<bsf-col size="xs" col="6">
								<h2 class="tits">25,600</h2>
								<p class="info">总浏览量<span class="pull-right">206<icon icon="arrow-top-b"></icon></span></p>
							</bsf-col>
							<bsf-col size="xs" col="6">
								<h2 class="tits">25,600</h2>
								<p class="info">总浏览量<span class="pull-right">206<icon icon="arrow-top-b"></icon></span></p>
							</bsf-col>
						</bsf-layout>
					</template>
				</bsf-panel>
			</bsf-col>
			<bsf-col size="xs" col="4">
				<bsf-panel :fullcav="true">
					<h5 class="panel-title" slot="title">图表 Echart</h5>
					<template slot="body">
						<bsf-chart cheight="98" :data="chartData1.chart" ctype="line" :fullcav="true" :legend="false" :areaStyle="false" :toolbox="false" :x="false" :y="false" :tooltip="false">
						</bsf-chart>
					</template>
				</bsf-panel>
			</bsf-col>
			<bsf-col size="xs" col="12">
				<bsf-panel class="titinfo" :hashead="false">
					<div class="cavmix-box" slot="body">
						<bsf-col size="xs" col="12" class="tits">
							<span class="pull-right text-right">
							<small>Average value of sales in the past month in: United states </small>
							<br />All sales: 162,862
						</span>
							<h4 class="tit">图表的完整名称主标题在这里</h4>
							<h5 class="tit1">图表的副标题</h5>
						</bsf-col>
						<bsf-col size="xs" col="9">
							<bsf-chart cheight="200" :data="chartData1.chart" ctype="line" :areaStyle="true" :toolbox="false">
							</bsf-chart>
							<p class="info">{{chartData1.chartmsg}}</p>
						</bsf-col>
						<bsf-col size="xs" col="3" class="countmsg">
							<template v-for="(count,index) in chartData1.chart">
								<h3> ${{count.data|count}}000</h3>
								<p>{{count.name}}</p>
								<bsf-progress :state="70" :end="true" type="info" striped animate></bsf-progress>
							</template>
						</bsf-col>
					</div>
				</bsf-panel>
			</bsf-col>
			<bsf-col size="xs" col="4">
				<bsf-panel>
					<h5 class="panel-title" slot="title">对话列表<bsf-label class="pull-right" type="danger">您有{{userMsg.length}}条对话</bsf-label></h5>
					<template slot="body">
						<bsf-media-list>
							<bsf-media v-for="(item,index) in userMsg" :data="item" :circle="true" :hasright="true" :middle="true"></bsf-media>
						</bsf-media-list>
					</template>
				</bsf-panel>
			</bsf-col>
			<bsf-col size="xs" col="4">
				<bsf-panel>
					<h5 class="panel-title" slot="title">消息列表<bsf-label class="pull-right" type="success">您有{{userMsg.length}}条消息</bsf-label></h5>
					<template slot="body">
						<bsf-media-list>
							<bsf-media v-for="(item,index) in msgmix" :data="item" type="unhead"></bsf-media>
							<bsf-media v-for="(item,index) in msgmix" :data="item" type="unhead" time="bottom"></bsf-media>
						</bsf-media-list>
					</template>
				</bsf-panel>
			</bsf-col>
			<bsf-col size="xs" col="4">
				<bsf-panel :unbg="true">
					<h5 class="panel-title" slot="title">聊天对话</h5>
					<template slot="body">
						<bsf-media-list type="chat">
							<bsf-media v-for="(item,index) in chat" :hasright="item.guest" :class="{guest:!!item.guest}">
								<template slot="left" v-if="!item.guest">
									<img class="media-object" src="../../assets/imgs/profilepicture.jpg" />
								</template>
								<template slot="right" v-else>
									<img class="media-object" src="../../assets/imgs/profilepicture.jpg" />
								</template>
								<template slot="body">
									<p class="clearfix"><span class="name">{{item.username}}</span><span class="time">{{item.time}}</span></p>
									<div>{{item.content}}</div>
								</template>
							</bsf-media>
						</bsf-media-list>
					</template>
				</bsf-panel>
			</bsf-col>
		</div>
	</div>
</template>
<script>
	import bsfLayout from "components/css/layout"
	import bsfCol from "components/css/col"
	import bsfInput from "components/css/form/input"
	//
	import bsfPanel from 'components/comp/panel'
	import bsfProgress from 'components/comp/progress'
	import bsfPageHeader from 'components/comp/pageheader'
	import bsfChart from 'components/comp/chart'
	import bsfNote from 'components/comp/notes/note'
	import bsfLabel from 'components/comp/label'
	import bsfBadges from 'components/comp/badges'
	import icon from 'components/comp/icon'

	import bsfMediaList from 'components/comp/list/medialist'
	import bsfMedia from 'components/comp/list/media'

	//

	//
	export default {
		components: {
			bsfLayout,
			bsfCol,
			bsfInput,
			//
			bsfPageHeader,
			bsfPanel,
			bsfProgress,
			bsfNote,
			bsfChart,
			//
			bsfLabel,
			bsfBadges,
			icon,
			//
			bsfMediaList,
			bsfMedia
		},
		data() {
			return {
				noteData: [{
					title: "拿最新设计规范",
					time: "09:00",
					system: true,
					state: "danger"
				}, {
					title: "回家吃饭",
					time: "11:30",
				}, {
					title: "提交最新计划",
					time: "14:20",
				}, {
					title: "领取本月工资",
					time: "17:30",
					state: "success"
				}, {
					title: "晚上公司聚餐哦",
					time: "19:30",
				}],
				chartData1: {
					chartmsg: "这是这个表单组件的一些备注信息",
					chart: [{
						name: '联盟广告',
						stack: '总量',
						data: [120, 132, 101, 134, 90, 230, 210]
					}, {
						name: '视频广告',
						stack: '总量',
						data: [220, 182, 191, 234, 290, 330, 310]
					}]
				},
				userMsg: [{
					user: "../../../assets/logo.png",
					username: "lopo",
					msgcount: 5,
					content: "对话消息内容对话消息内容对话",
					time: "2017-1-22 18:39:45"
				}, {
					user: "../../../assets/logo.png",
					username: "lopo1983",
					msgcount: 12,
					content: "对话消息内容",
					time: "2017-1-22 18:38:45"
				}, {
					user: "assets/logo.png",
					username: "lopo",
					msgcount: 52,
					content: "对话消息内容",
					time: "2017-1-22 18:37:45"
				}, {
					user: "assets/logo.png",
					username: "lopo1983",
					msgcount: 78,
					content: "对话消息内容",
					time: "2017-1-22 18:30:45"
				}, {
					user: "assets/logo.png",
					username: "lopo",
					msgcount: 102,
					content: "对话消息内容",
					time: "2017-1-21 18:20:45"
				}, {
					user: "assets/logo.png",
					username: "lopo1983",
					msgcount: 112,
					content: "对话消息内容",
					time: "2017-1-21 17:30:45"
				}, {
					user: "assets/logo.png",
					username: "lopo1983",
					msgcount: 122,
					content: "对话消息内容",
					time: "2017-1-21 16:30:45"
				}],
				chat: [{
					user: "../../../assets/logo.png",
					username: "lopo",
					content: "对话消息内容对话消息内容对话",
					time: "2017-1-22 18:39:45",
					guest: true
				}, {
					user: "../../../assets/logo.png",
					username: "lopo1983",
					content: "对话消息内容1",
					time: "2017-1-22 18:38:45"
				}, {
					user: "assets/logo.png",
					username: "lopo",
					content: "对话消息内容2",
					time: "2017-1-22 18:37:45",
					guest: true
				}, {
					user: "assets/logo.png",
					username: "lopo1983",
					content: "对话消息内容3",
					time: "2017-1-22 18:30:45"
				}, {
					user: "assets/logo.png",
					username: "lopo",
					content: "对话消息内容4",
					time: "2017-1-21 18:20:45",
					guest: true
				}, {
					user: "assets/logo.png",
					username: "lopo1983",
					content: "对话消息内容5",
					time: "2017-1-21 17:30:45",
					guest: true
				}, {
					user: "assets/logo.png",
					username: "lopo1983",
					content: "对话消息内容6",
					time: "2017-1-21 16:30:45"
				}],
				userInfor:[{
					name:"lopo",
					sex:1,
					inTime:"1983-02-16",
					info:"我就我不一样的烟火"
				},{
					name:"lopo1983",
					sex:0,
					inTime:"1987-09-01",
					info:"我是一只小白兔啊咿呀咿呀哟"
				}],
				msgmix: [{
					user: "lopo",
					content: "There are many variations of passages of Lorem Ipsum available",
					todotime: "2017-2-5 16:30:45",
					time: "2017-1-21 16:30:45"
				}, {
					user: "lopo1983",
					content: "There are many variations of passages of Lorem Ipsum available",
					todotime: "2017-2-5 16:30:45",
					time: "2017-1-21 16:30:45"
				}]
			}
		},
		methods: {},
		filters: {
			count(data) {
				let sum = 0;
				data.forEach(item => sum += item)
				return sum;
			}
		}
	}
</script>
<style lang="less">
	@import (reference) "../../assets/lib/css.less";
	.cavmix-box {
		.tits {
			span.pull-right {
				.mgt(10px);
			}
		}
		.countmsg {
			/*h2,
			h3,
			h4,
			h5 {
				.mgt(5px);
			}*/
			p {
				.mgb(0);
			}
		}
		.info {
			color: @cc2;
			.mgl(2*@mpb);
			.mgt;
		}
	}
</style>


// WEBPACK FOOTER //
// temp1.vue?585bde0c